import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../theme";
import ProgressCircle from "./progressCircle";

const normalizeProgress = (progress) => {
  const value = Number(progress);
  if (!Number.isFinite(value) || value <= 0) return 0;
  return value > 1 ? Math.min(value / 100, 1) : value;
};

const StatBox = ({
  title = "",
  subtitle = "",
  icon = null,
  iconColor,
  progress,
  increase = "",
  trend,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const showProgress = progress !== undefined && progress !== null;
  const resolvedTrend =
    trend ||
    (typeof increase === "string" && increase.trim().startsWith("-")
      ? "down"
      : increase
        ? "up"
        : "neutral");
  const trendColor =
    resolvedTrend === "down"
      ? colors.redAccent[500]
      : resolvedTrend === "up"
        ? colors.greenAccent[500]
        : colors.grey[300];

  return (
    <Box width="100%" px={2} py={1.5}>
      <Box display="flex" justifyContent="space-between" alignItems="flex-start" gap={1.5}>
        <Box minWidth={0}>
          {icon && (
            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: 1.5,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 1,
                bgcolor: "action.hover",
                color: iconColor || colors.redAccent[500],
                "& svg": { fontSize: 22 },
              }}
            >
              {icon}
            </Box>
          )}
          <Typography
            variant="h4"
            fontWeight={800}
            noWrap
            title={title}
            sx={{ color: colors.grey[100] }}
          >
            {title}
          </Typography>
        </Box>
        {showProgress && (
          <ProgressCircle progress={normalizeProgress(progress)} />
        )}
      </Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mt={1} gap={1}>
        <Typography variant="body2" color="text.secondary" noWrap>
          {subtitle}
        </Typography>
        {increase ? (
          <Typography variant="body2" fontWeight={700} sx={{ color: trendColor }}>
            {increase}
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
};

export default StatBox;
